import { format } from 'date-fns';
import { Plus } from 'lucide-react';

import {
    type Range,
    RANGES,
} from './range';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

function getGreeting(hour: number): string {
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
}

interface DashboardHeaderProps {
    name: string;
    range: Range;
    onRangeChange: (range: Range) => void;
    onNewOrder?: () => void;
}

export function DashboardHeader({
    name,
    range,
    onRangeChange,
    onNewOrder,
}: DashboardHeaderProps) {
    const now = new Date();
    const greeting = getGreeting(now.getHours());

    return (
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div className="space-y-1">
                <h1 className="text-xl font-semibold text-foreground">
                    {greeting}
                    ,
                    {' '}
                    <span className="text-primary">{name}</span>
                </h1>
                <p className="text-sm text-muted-foreground">
                    {format(now, 'EEEE, dd MMMM yyyy')}
                </p>
            </div>

            <div className="flex items-center gap-2.5">
                <div className="flex items-center rounded-lg bg-muted p-0.5">
                    {RANGES.map((value) => {
                        const handleClick = () => onRangeChange(value);
                        return (
                            <button
                                key={value}
                                type="button"
                                onClick={handleClick}
                                className={cn(
                                    'rounded-md px-2.5 py-1.5 text-xs font-semibold transition-colors',
                                    range === value
                                        ? 'bg-card text-foreground shadow-xs'
                                        : 'text-muted-foreground hover:text-foreground',
                                )}
                            >
                                {value}
                            </button>
                        );
                    })}
                </div>
                <Button
                    onClick={onNewOrder}
                    className="h-9 gap-2 rounded-lg font-semibold shadow-sm"
                >
                    <Plus className="h-4 w-4" />
                    New Order
                </Button>
            </div>
        </div>
    );
}
